import React from 'react';
import { ApiClient } from '@flashbacktech/flashbackclient/api';

interface ApiContextType {
  apiClient: ApiClient;
}

export const ApiContext = React.createContext<ApiContextType | null>(null);

export const ApiProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const apiClient = new ApiClient(process.env.REACT_APP_API_URL || '');
  return <ApiContext.Provider value={{ apiClient }}>{children}</ApiContext.Provider>;
};

// Custom hook to use the API client
export const useApi = () => {
  const context = React.useContext(ApiContext);
  if (!context) {
    throw new Error('useApi must be used within an ApiProvider');
  }
  return context;
};
